

import { IconProps } from "../../models/Icon";

export function PadlockIcon({ size = 20, color = "#000", opacity = "1" }: IconProps) {
  return (
    <svg width={size} height={size} opacity={opacity} viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
        d="M9.9375 5.34326H3.10156V2.28076C3.10156 1.8583 3.44473 1.51514 3.86719 1.51514H7.25781C7.68027 1.51514 8.02344 1.8583 8.02344 2.28076V3.21045C8.02344 3.27061 8.07266 3.31982 8.13281 3.31982H8.89844C8.95859 3.31982 9.00781 3.27061 9.00781 3.21045V2.28076C9.00781 1.31416 8.22441 0.530762 7.25781 0.530762H3.86719C2.90059 0.530762 2.11719 1.31416 2.11719 2.28076V5.34326H1.1875C0.945508 5.34326 0.75 5.53877 0.75 5.78076V11.0308C0.75 11.2728 0.945508 11.4683 1.1875 11.4683H9.9375C10.1795 11.4683 10.375 11.2728 10.375 11.0308V5.78076C10.375 5.53877 10.1795 5.34326 9.9375 5.34326ZM5.94531 8.5835V9.30811C5.94531 9.36826 5.89609 9.41748 5.83594 9.41748H5.28906C5.22891 9.41748 5.17969 9.36826 5.17969 9.30811V8.5835C5.06683 8.50247 4.98259 8.38772 4.9391 8.25577C4.89561 8.12383 4.89511 7.98148 4.93767 7.84923C4.98023 7.71697 5.06365 7.60164 5.17594 7.51982C5.28822 7.438 5.42357 7.39391 5.5625 7.39391C5.70143 7.39391 5.83678 7.438 5.94906 7.51982C6.06135 7.60164 6.14477 7.71697 6.18733 7.84923C6.22989 7.98148 6.22939 8.12383 6.1859 8.25577C6.14241 8.38772 6.05817 8.50247 5.94531 8.5835Z" 
        fill={color} 
        fillOpacity="0.85"
        />
    </svg>
  )
}





